import React, { useEffect } from "react";
import { TurnrSnackbarAlert } from "./TurnrSnackbar.jsx";
import { serviceHasError, serviceIsSuccessfullyFetched } from "rylak-common";

function titleHelperError({ titleFn, title, serviceData }) {
    return (titleFn && titleFn(serviceData)) || title;
}

function titleHelperSuccess({ titleFn, title, serviceData }) {
    return (titleFn && titleFn(serviceData)) || title || "Success!";
}

function contentHelper({ contentFn, content, serviceData }) {
    return (contentFn && contentFn(serviceData)) || serviceData?.error || serviceData?.data?.detail || content;
}

export function TurnrServiceErrorSnackbar(props) {
    const { appProps, serviceData, serviceFailedFn } = props;
    useEffect(() => {
        if (serviceFailedFn ? serviceFailedFn(serviceData) : serviceHasError(serviceData)) {
            let title = titleHelperError(props);
            let content = contentHelper(props);
            if (!title && content) {
                title = content;
                content = "";
            } else {
                if (!title && !content) {
                    title = "Something went wrong";
                }
            }

            appProps?.openSnackbar({
                Component: TurnrSnackbarAlert,
                componentProps: {
                    title: title,
                    content: content,
                    type: "ERROR",
                    traceId: serviceData?.traceId,
                },
                openTime: 15000,
            });
        }
    }, [serviceData]);

    return null;
}

export function TurnrServiceSuccessSnackbar(props) {
    const { appProps, serviceData, serviceFailedFn } = props;
    useEffect(() => {
        if ((!serviceFailedFn || !serviceFailedFn(serviceData)) && serviceIsSuccessfullyFetched(serviceData)) {
            appProps?.openSnackbar({
                Component: TurnrSnackbarAlert,
                componentProps: {
                    title: titleHelperSuccess(props),
                    content: contentHelper(props),
                    type: "SUCCESS",
                },
            });
        }
    }, [serviceData]);

    return null;
}

export function TurnrServiceSnackbar(props) {
    const { appProps, serviceData, serviceFailedFn, errorProps, successProps, errorTitle, successTitle } = props;

    return (
        <>
            <TurnrServiceErrorSnackbar {...errorProps} title={errorTitle} serviceData={serviceData} serviceFailedFn={serviceFailedFn} appProps={appProps} />
            <TurnrServiceSuccessSnackbar {...successProps} title={successTitle} serviceData={serviceData} serviceFailedFn={serviceFailedFn} appProps={appProps} />
        </>
    );
}
